import script from "./TexturesGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./TexturesGenerator.vue?vue&type=script&setup=true&lang=js"

import "./TexturesGenerator.vue?vue&type=style&index=0&id=21534075&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21534075"]])

export default __exports__